export default "__VITE_ASSET__BbYfx_6e__"